import { useEffect, useState } from 'react';
import { apiJson } from '../api/client.js';
import { ClientFaqViewer } from '../components/ClientFaqViewer.jsx';
import { useAuth } from '../context/AuthContext.jsx';

export function MyFaqPage() {
  const { user } = useAuth();
  const [faq, setFaq] = useState(null);
  const [contact, setContact] = useState(null);
  const [timeBalance, setTimeBalance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const reqs = [apiJson('/api/my/faq'), apiJson('/api/my/contact').catch(() => null)];
    if (user?.capabilities?.view_time_balance) {
      reqs.push(apiJson('/api/my/time-balance').catch(() => null));
    }
    Promise.all(reqs)
      .then(([f, c, balance]) => {
        setFaq(f);
        setContact(c);
        setTimeBalance(balance ?? null);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [user?.capabilities?.view_time_balance]);

  if (!user?.capabilities?.view_client_faq) {
    return (
      <div className="auth-card flat">
        <p>FAQ is not available for your account. Contact your agency.</p>
      </div>
    );
  }

  return (
    <div>
      <h2 style={{ marginTop: 0 }} data-tour="page-title">Forms & questionnaires</h2>
      <p className="muted">
        Complete intake forms and access resources shared by your agency.
      </p>

      {loading ? <p className="muted">Loading…</p> : null}
      {error ? <p className="err">{error}</p> : null}

      {timeBalance ? (
        <div className="auth-card flat" style={{ marginBottom: '1rem' }}>
          <h3 style={{ marginTop: 0 }}>Prepaid hours</h3>
          <p>
            <strong>{timeBalance.remaining.toFixed(1)}</strong> h remaining of {timeBalance.time_limit} h (
            {timeBalance.percent_used}% used)
          </p>
        </div>
      ) : null}

      {contact?.support_email ? (
        <p className="muted small" style={{ marginBottom: '1rem' }}>
          Questions?{' '}
          <a href={`mailto:${contact.support_email}`}>{contact.support_email}</a>
        </p>
      ) : null}

      {!loading && faq ? (
        <div data-tour="faq-content">
          <ClientFaqViewer categories={faq.categories} plan={faq.plan} />
        </div>
      ) : null}
    </div>
  );
}
